<template>
    <div class="info-area">
        <div class="container">
            <div class="launch-bar-actions-wrapper">
                <div>
                    <router-link class="level-display" :to="/u/+$store.state.user.username">
                        <span class="nowrap">
                            <img src="/assets/dipocaco/level_x64.png" alt="" class="currency-icon" title="Level"> {{ $store.getters.level }}
                        </span>
                    </router-link>

                    <router-link class="credit-display" to="/shop">
                        <span class="nowrap">
                            <img src="/assets/dipocaco/currency_x64.png" alt="" class="currency-icon" title="Currency"> {{ $store.getters.formattedCredit }}
                        </span>
                    </router-link>


                    <a href="javascript:" v-on:click="showQuests" :class="'quests-link'+($store.state.user.quests.filter(q => q.completed_at !== null && q.collected_at === null).length > 0 ? ' collectible' : '')">
                        <i class="fa-solid fa-clipboard-question"></i>
                    </a>

                    <music-player/>
                </div>

                <div class="logo-button-wrapper" v-on:contextmenu.prevent="hardReload">
                    <router-link to="/home">
                        <img :src="getBallAsset()" class="logo-button" alt="main-menu-icon"/>
                    </router-link>
                </div>
            </div>

            <div class="offcanvas offcanvas-start" tabindex="-1" id="daily-quest-offcanvas" aria-labelledby="daily-quest-offcanvas-label">
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title" id="daily-quest-offcanvas-label">{{ $t('quests.title') }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body">
                    <div :class="'card mb-2 text-start'+(quest.collected_at !== null ? ' collected' : '')" v-for="quest in $store.state.user?.quests ?? []">
                        <div class="card-body">
                            <p>
                                {{ getTextForQuest(quest) }} <type-icon v-if="quest.quest_type === 'card_type_pulls'" :type="quest.requirement"/>
                            </p>

                            <div class="progress rounded">
                                <div class="progress-bar progress-bar-striped bg-info progress-bar-animated rounded" role="progressbar" :aria-valuenow="quest.requirement_progress" aria-valuemin="0" :aria-valuemax="quest.requirement_quantity" :style="'width: '+HelperService.percentage(quest.requirement_progress, quest.requirement_quantity)+'%;'"></div>
                            </div>

                            <a v-if="quest.completed_at !== null && quest.collected_at === null" href="javascript:" :class="'mt-2 btn btn-sm btn-dark w-100'+(quest.collected_at !== null ? ' collected' : '')" v-on:click="collectQuestRewards(quest)">
                                {{ $t('quests.collect') }} {{ quest.reward_quantity }}
                                <currency-icon v-if="quest.reward_type === 'credits'"/>
                                <span v-else>XP</span>
                            </a>
                            <a v-if="quest.collected_at !== null" href="javascript:" :class="'mt-2 btn btn-sm btn-black w-100'+(quest.collected_at !== null ? ' collected' : '')" disabled>
                                {{ $t('quests.collected') }} {{ quest.reward_quantity }}
                                <currency-icon v-if="quest.reward_type === 'credits'"/>
                                <span v-else>XP</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HelperService from "../../HelperService";
import CurrencyIcon from "./CurrencyIcon.vue";
import TypeIcon from "./TypeIcon.vue";
import MusicPlayer from "./MusicPlayer.vue";

export default {
    name: "LaunchBar",
    components: {MusicPlayer, TypeIcon, CurrencyIcon},
    computed: {
        HelperService() {
            return HelperService
        }
    },
    methods: {
        toggleMenu() {
            document.getElementById('game-menu').classList.toggle('open')
        },
        getBallAsset() {
            if (this.$store.getters.isSpring) {
                return '/assets/dipocaco/pokeball_spring.webp';
            }

            if (this.$store.getters.isSummer) {
                return '/assets/dipocaco/pokeball_summer.webp';
            }

            if (this.$store.getters.isSpookySeason) {
                return '/assets/dipocaco/pokeball_hw.webp';
            }

            if (this.$store.getters.isWinter) {
                return '/assets/dipocaco/pokeball_winter.webp';
            }

            return '/assets/dipocaco/pokeball.webp';
        },
        hardReload() {
            window.location.reload(true);
        },
        showQuests() {
            $("#daily-quest-offcanvas").offcanvas('toggle');
        },
        getTextForQuest(quest) {
            switch (quest.quest_type) {
                case 'booster_openings':
                    return this.$i18n.t('quests.booster_openings', quest.requirement_quantity);
                case 'booster_purchases':
                    return this.$i18n.t('quests.booster_purchases', quest.requirement_quantity);
                case 'card_rarity_pulls':
                    return this.$i18n.t('quests.card_rarity_pulls', {quantity: quest.requirement_quantity, rarity: quest.requirement});
                case 'card_type_pulls':
                    return this.$i18n.t('quests.card_type_pulls', {quantity: quest.requirement_quantity, type: quest.requirement});
                case 'item_purchases':
                    return this.$i18n.t('quests.item_purchases.'+quest.requirement, quest.requirement_quantity);
                case 'trades_done':
                    return this.$i18n.t('quests.trades_done', quest.requirement_quantity);
                case 'quizzes_done':
                    return this.$i18n.t('quests.quizzes_done', quest.requirement_quantity);
                case 'wordles_done':
                    return this.$i18n.t('quests.wordles_done', quest.requirement_quantity);
            }
        },
        collectQuestRewards(quest) {
            if (quest.collected_at !== null) {
                return false;
            }

            axios.get('/api/quests/'+quest.id+'/collect').then((response) => {
                this.$store.commit('updateUserData');
                iziToast.success({title: this.$i18n.t('quests.collect_success')});
            })
        }
    }
}
</script>

<style scoped>
.info-area {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;

    display: flex;
    height: 3.5em;
    background-color: white;
    text-align: right;
    border-bottom: 1px solid slategrey;
    font-weight: bolder;

    .launch-bar-actions-wrapper {
        white-space: nowrap;
        font-size: 1.3em;
        display: flex;
        justify-content: space-between;
        padding-top: 0.25em;
        padding-left: 0.75em;
    }

    .logo-button-wrapper {
        z-index: 110;
        margin-top: -2.75em;
        margin-right: -2.25em;

        .logo-button {
            max-width: 8em;
            -webkit-transition: -webkit-transform .4s ease-in-out;
            transition:         transform .4s ease-in-out;
        }

        .logo-button:hover {
            cursor: pointer;
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .credit-display, .level-display {
        font-size: 1.5em !important;
        text-decoration: none;
        padding-right: 1em;

        img {
            max-height: 1em;
            margin-top: -0.2em;
        }
    }

    .quests-link {
        color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
        font-size: 1.5em !important;
        text-decoration: none;

        &:is(.collectible) {
            color: darkgoldenrod;
        }
    }

    .collected {
        opacity: 0.8;
    }
}
</style>
